var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5821 5.18613C19.3522 4.32559 18.6745 3.64797 17.814 3.41797C16.2541 3 10 3 10 3C10 3 3.74582 3 2.18598 3.41797C1.32559 3.64797 0.647812 4.32559 0.417852 5.18613C0 6.74582 0 10.0001 0 10.0001C0 10.0001 0 13.2543 0.417852 14.8139C0.647812 15.6744 1.32559 16.3522 2.18598 16.5822C3.74582 17 10 17 10 17C10 17 16.2541 17 17.814 16.5822C18.6745 16.3522 19.3522 15.6744 19.5821 14.8139C20 13.2543 20 10.0001 20 10.0001C20 10.0001 20 6.74582 19.5821 5.18613ZM7.99988 13.0002V7.00004L13.1959 10.0001L7.99988 13.0002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYt);
export default __webpack_public_path__ + "static/media/icon-yt.75c3c36b03fe52040e64d4c0d3cb9074.svg";
export { ForwardRef as ReactComponent };